import React from 'react'
import FusionChart from './FusionChart'

const StackedChart = item => {
    const dataSource = {
        chart: {
            bgColor: '#ffffff',
            usePlotGradientColor: '0',
            stack100percent: '0',
            theme: 'candy',
            yaxismaxvalue: '100',
            decimals: '1',
            drawcrossline: '0',
            numvisibleplot: '8',
            plottooltext: '<b>$dataValue</b>  $seriesName',
            showvalues: '0',
            chartLeftMargin: '20',
            chartRightMargin: '20',
            chartTopMargin: '20',
            chartBottomMargin: '20',
            showBorder: '0',
            showCanvasBorder: '0',
            labelWidth: '100',
            seriesname: '0',
            // showLegend: '0',
            labelFontBold: '1',
            numbersuffix: '%',
            showsum: '0',
            usepercentdistribution: '1',
            showxaxispercentvalues: '0'
        },
        categories: [
            {
                category: [
                    {
                        label: '2024'
                    },
                    {
                        label: '2023'
                    },
                    {
                        label: '2022'
                    },
                    {
                        label: '2021'
                    }
                ]
            }
        ],
        dataset: [
            {
                seriesname: 'Positive',
                color: '#55B496',
                data: [
                    {
                        value: 50
                    },
                    {
                        value: 25
                    },
                    {
                        value: 61
                    },
                    {
                        value: 53
                    }
                ]
            },
            {
                seriesname: 'Neutral',
                color: '#ebbf44',
                data: [
                    {
                        value: 25
                    },
                    {
                        value: 25
                    },
                    {
                        value: 21
                    },
                    {
                        value: 21
                    }
                ]
            },
            {
                seriesname: 'Negative',
                color: '#FA6738',
                data: [
                    {
                        value: 25
                    },
                    {
                        value: 50
                    },
                    {
                        value: 18
                    },
                    {
                        value: 25
                    }
                ]
            }
        ]
    }
    return (
        <FusionChart
            type="stackedcolumn2d"
            width="100%"
            height="200"
            dataFormat="JSON"
            dataSource={dataSource}
        />
    )
}

export default StackedChart
